"use client";

import clsx from "clsx";
import DangerouslySetHtmlContent from "@/components/ui/InnerHTML";
import type { ProductPageStoryblok } from "@/generated/sb/sb-types";
import type { ProductDetails } from "@/lib/centra/formatters";
import { calculateDiscountPercentage } from "@/lib/centra/formatters/utils";
import { DepictView } from "../../ProductDisplayPage/DepictView";
import { ProductAccordions } from "../../ProductDisplayPage/ProductAccordions";
import { useProductContext } from "../../ProductProvider";
import Price from "../Price";
import { ProductFeatures } from "../ProductFeatures";
import styles from "./index.module.css";

export interface ProductInformationProps {
  product: ProductDetails;
  storyblokAccordion?: ProductPageStoryblok["accordion"];
}

const ProductInformation = ({
  storyblokAccordion,
  product,
}: ProductInformationProps) => {
  const { activeVariant } = useProductContext();
  return (
    <>
      <DepictView productId={activeVariant?.sizes?.[0].itemId?.split("-")[1]} />
      <section className={styles.root}>
        <div className={styles.wrapper}>
          <h1 className={styles.title}>{activeVariant?.name}</h1>
          <Price
            isForcedSalePrice={activeVariant?.isForcedSalePrice}
            price={{
              price: activeVariant?.price!,
              priceAsNumber: activeVariant?.priceAsNumber!,
              priceBeforeDiscount: activeVariant?.priceBeforeDiscount!,
              priceBeforeDiscountAsNumber:
                activeVariant?.priceBeforeDiscountAsNumber!,
              discountPercent: calculateDiscountPercentage(
                activeVariant?.priceBeforeDiscountAsNumber!,
                activeVariant?.priceAsNumber!,
              ),
              productOnSale:
                activeVariant?.showAsOnSale ??
                activeVariant?.priceAsNumber !==
                  activeVariant?.priceBeforeDiscountAsNumber,
            }}
            className={styles.price}
          />
          {activeVariant?.shortDescription && (
            <div className={clsx(styles.lead, styles.leadDesktop)}>
              <DangerouslySetHtmlContent
                html={activeVariant.shortDescription}
                type="html"
              />
            </div>
          )}
          <ProductFeatures
            features={product.features}
            className={styles.desktopOnly}
          />
          <div className={styles.accordion}>
            <ProductAccordions
              product={product}
              storyblokAccordion={storyblokAccordion}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductInformation;
